import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { WSIBCategorySetup } from "../../components/WSIBCategorySetup";

export const WSIBCategorySetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Category Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Category Setup", navigateTo: "#" }
      ]}
      mainContents={<WSIBCategorySetup />}
    />
  );
};
